
// eslint-disable-next-line @typescript-eslint/no-var-requires
const api = require('./jitsi_external_api')
export default window.JitsiMeetExternalAPI || api